// extracted by mini-css-extract-plugin
export default {"container":"pQ-z","title":"qQ-z","link":"rQ-z"};